<div class="container">
    <h1>🗳️ Rösta i fototävlingen</h1>

    <p>
        Denna guide visar dig hur du röstar på bilder i fototävlingen. Genom att rösta
        placerar du bilderna i den ordning du tycker är bäst.
    </p>

    <h2>Komma igång med röstning</h2>

    <div class="step">
        <p class="step-number">Steg 1: Öppna röstningsfunktionen</p>
        <p>
            Efter att du har loggat in, klicka på menyn
            <span class="highlight">"Tävling"</span> i navigeringsfältet högst upp på sidan.
            Välj sedan <span class="highlight">"Rösta"</span> i menyn som öppnas.
        </p>
        <img src="assets/menu.jpg" alt="Meny för att komma till röstning" style="
                        width: 100%;
                        max-width: 600px;
                        margin: 15px 0;
                        border: 1px solid #ddd;
                        border-radius: 4px;
                    " />
    </div>

    <div class="step">
        <p class="step-number">Steg 2: Se bilderna du kan rösta på</p>
        <p>
            Du kommer nu till röstningssidan där alla bilder i tävlingen visas. Bilderna är
            placerade i en slumpmässig ordning från början.
        </p>
        <img src="assets/vote_basic.jpg" alt="Röstningssida med bilder" style="
                        width: 100%;
                        max-width: 600px;
                        margin: 15px 0;
                        border: 1px solid #ddd;
                        border-radius: 4px;
                    " />
    </div>

    <div class="note">
        <strong>ℹ️ Obs:</strong> Dina egna bilder visas inte här och kan inte rösta på. Du
        kan bara rösta på andra deltagares bilder.
    </div>

    <h2>Granska bilderna</h2>

    <div class="step">
        <p class="step-number">Förstora en bild</p>
        <p>
            För att se en bild i större format, klicka på bilden. Den visas då uppförstorad
            så stor som webbläsarfönstret tillåter. När du är klar med att studera bilden,
            stäng ner den genom att klicka på <strong>krysset (×)</strong> uppe till höger.
        </p>
        <img src="assets/vote_zoom.jpg" alt="Förstorad bild" style="
                        width: 100%;
                        max-width: 600px;
                        margin: 15px 0;
                        border: 1px solid #ddd;
                        border-radius: 4px;
                    " />
    </div>

    <h2>Placera bilderna i ordning</h2>

    <h3>Dra och släpp bilder</h3>

    <div class="step">
        <p class="step-number">Ändra bildernas placering</p>
        <p>För att rösta och placera bilderna i din önskade ordning:</p>
        <ol>
            <li>Ta tag i den bild du vill flytta</li>
            <li>Dra bilden till den position där du vill att den ska ligga</li>
            <li>Släpp bilden på den plats som bilden ska ha</li>
        </ol>
        <p>Bilderna byter då plats och din röstning uppdateras.</p>
    </div>

    <h3>Jämför bilder sida vid sida</h3>

    <div class="step">
        <p class="step-number">Använd jämförelsefunktionen</p>
        <p>
            Om du har svårt att bestämma dig för vilken av två bilder som är bäst kan du
            använda jämförelsefunktionen:
        </p>
        <ol>
            <li>Klicka på <strong>kugghjulet</strong> vid en bild</li>
            <li>
                En ruta öppnas med två eller tre bilder intill varandra (tre bilder om du
                inte är vid första eller sista bilden, annars två)
            </li>
            <li>För musen över bilderna för att zooma in dem</li>
            <li>
                Använd <strong>scrollhjulet på musen</strong> för att ändra zoomningsgraden
            </li>
            <li>
                Byt plats på bilderna genom att klicka på de
                <strong>dubbelriktade pilarna</strong> längst ner i skarven mellan bilderna
            </li>
            <li>
                Stäng fönstret med <strong>krysset (×)</strong> uppe till höger när du är
                klar
            </li>
        </ol>
        <img src="assets/vote_compare.jpg" alt="Jämför bilder" style="
                        width: 100%;
                        margin: 15px 0;
                        border: 1px solid #ddd;
                        border-radius: 4px;
                    " />
    </div>

    <h2>Kommentera bilder</h2>

    <div class="step">
        <p class="step-number">Lägg till bildkommentarer</p>
        <p>
            Du kan skriva kommentarer till bilderna genom att klicka på
            <strong>pennan</strong> i anslutning till bilden. En kommentarsruta öppnas där
            du kan skriva din feedback.
        </p>
        <img src="assets/vote_comment.jpg" alt="Kommentera bild" style="
                        width: 100%;
                        max-width: 600px;
                        margin: 15px 0;
                        border: 1px solid #ddd;
                        border-radius: 4px;
                    " />
    </div>

    <div class="note">
        <strong>💡 Tips för konstruktiva kommentarer:</strong>
        <ul>
            <li>Fokusera på vad du uppskattade i bilden</li>
            <li>
                Ge konkreta förslag på vad som skulle kunnat lyfta bilden till ännu högre
                höjder
            </li>
            <li>Var alltid konstruktiv och respektfull</li>
            <li>
                Undvik negativa kommentarer - om du inte har något positivt att säga, avstå
                från att kommentera
            </li>
        </ul>
    </div>

    <h2>Spara din röstning</h2>

    <div class="step">
        <p class="step-number">Steg 1: Kontrollera din röstning</p>
        <p>
            När du är nöjd med att bilderna ligger i rätt ordning och har skrivit eventuella
            kommentarer, klicka på knappen <span class="highlight">"Spara röstning"</span>.
        </p>
        <img src="assets/vote_reg.jpg" alt="Spara röstning" style="
                        width: 100%;
                        max-width: 600px;
                        margin: 15px 0;
                        border: 1px solid #ddd;
                        border-radius: 4px;
                    " />
    </div>

    <div class="step">
        <p class="step-number">Steg 2: Granska och registrera</p>
        <p>
            En sammanfattning visas där du kan dubbelkolla att du är nöjd med din röstning
            och alla poäng. När du är säker, klicka på
            <span class="highlight">"Registrera röstningen"</span>.
        </p>
    </div>

    <div class="info-box">
        <strong>✏️ Kan jag ändra min röstning?</strong>
        <p>
            Ja! Du kan gå in och justera din röstning så många gånger du vill ända fram till
            sista datum för röstning. Gör bara om proceduren ovan så sparas din uppdaterade
            röstning.
        </p>
    </div>

    <h2>Vanliga frågor</h2>

    <div class="info-box">
        <h3>❓ Varför ser jag inte mina egna bilder?</h3>
        <p>
            För att göra röstningen rättvis kan du inte rösta på dina egna bilder. De visas
            därför inte i röstningsläget.
        </p>
    </div>

    <div class="info-box">
        <h3>❓ Hur fungerar poängsättningen?</h3>
        <p>
            Bilderna får poäng baserat på deras placering. Den bild du placerar högst upp
            får flest poäng, och så vidare nedåt. Exakt poängsystem kan variera mellan olika
            tävlingar.
        </p>
    </div>

    <div class="info-box">
        <h3>❓ Måste jag kommentera alla bilder?</h3>
        <p>
            Nej, kommentarer är helt frivilliga. Du kan välja att kommentera de bilder du
            vill ge feedback på.
        </p>
    </div>

    <div class="info-box">
        <h3>❓ När stänger röstningen?</h3>
        <p>
            Sista datum för röstning visas på tävlingssidan. Se till att registrera din
            röstning innan detta datum!
        </p>
    </div>

    <h2>Behöver du hjälp?</h2>
    <p>
        Om du stöter på problem vid röstning eller har frågor om tävlingen, kontakta
        tävlingsarrangören.
    </p>

    <p style="margin-top: 40px; text-align: center; color: #666; font-size: 0.9em">
        Lycka till med din röstning! 🎉
    </p>
</div>